import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import TablesAndFiguresMenu from "./TablesAndFiguresMenu";
import GuidelineTablesAndFigures from "./GuidelineTablesAndFigures";

const ModernTablesAndFigures = () => {
  const { pathname } = useLocation();
  const [guideline, setGuideline] = useState(null);

  useEffect(() => {
    const cleanPath = pathname.replace(/\/$/, "");
    const parts = cleanPath.split("/");

    setGuideline(parts.length > 3 ? parts[3] : null);
  }, [pathname]);

  return (
    <div>
      {guideline ? <GuidelineTablesAndFigures glPage={guideline} /> : <TablesAndFiguresMenu />}
    </div>
  );
};
export default ModernTablesAndFigures;
